import styled from "styled-components";

export const ForgotPasswordContainer = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100%;
  min-height: 100vh;
  position: relative;

  background: ${(props) => props.theme.colors["black-900"]};

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 0 1.5rem;
  }
`;

export const CheckNewPasswordContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 25%;
  min-width: 300px;
`;

export const PassRules = styled.p`
  color: ${(props) => props.theme.colors["white"]};
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

export const RequirementsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 2rem;
`;

export const RequirementItem = styled.div<{ isValid: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: ${(props) => props.theme.colors["white"]};
  font-size: 0.875rem;
  transition: color 0.2s ease;

  span {
    font-weight: ${(props) => (props.isValid ? "500" : "400")};
  }
`;
